import React, { forwardRef, ButtonHTMLAttributes } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean
  name?: string
  type?: 'button' | 'submit' | 'reset'
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  title?: string
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ disabled = false, name = '', type = 'button', className = null, onClick, children, ...props }, ref) => {
    const handleClick: React.MouseEventHandler<HTMLButtonElement> = event => {
      if (disabled) {
        event.preventDefault()
        return
      }
      if (onClick) {
        onClick(event)
      }
    }

    return (
      <button
        ref={ref}
        disabled={disabled}
        name={name}
        type={type}
        className={className || undefined}
        onClick={handleClick}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
